var UIConfirm = /** @class */ (function () {
    function UIConfirm() {
    }
    UIConfirm.registerImpl = function (showConfirm) {
        if (typeof showConfirm === 'function') {
            UIConfirm.showConfirm = showConfirm;
        }
    };
    UIConfirm.show = function (message, postEvent) {
        UIConfirm.showConfirm && UIConfirm.showConfirm(message, postEvent);
    };
    return UIConfirm;
}());
export default UIConfirm;

//# sourceMappingURL=UIConfirm.js.map
